import { throttle } from './throttle';

const headerScroll = () => {
	const header = document.getElementById("masthead");
	window.addEventListener(
		"scroll",
		throttle(() => {
			if (window.scrollY > 10) {
				header.classList.add("scrolled");
			} else {
				header.classList.remove("scrolled");
			}
		}, 100)
	);
};

export { headerScroll };